import type ChargebeeAddon from './ChargebeeAddon'
import { Pricing, PricingType } from './Pricing'

const LATAM_COUNTRIES = ['ar', 'co', 'mx', 'cl']
const REGION_COUNTRIES = ['fr', 'es', 'it', 'pt', 'de', 'gb']

const getF25Country = (country: string) => {
  if (LATAM_COUNTRIES.includes(country)) {
    return 'latam'
  }
  if (REGION_COUNTRIES.includes(country)) {
    return country
  }
  return 'world'
}

function getF25PlanPricing(addons: ChargebeeAddon[], country: string) {
  const areaAddons = addons.filter((addon) => {
    return addon.isF25Compatible(getF25Country(country))
  })

  // Group addons by period unit (month, year, six_months)
  const pricingAddonInitialState: PricingType = { month: {}, year: {}, six_months: {} }
  const pricingAddon = areaAddons?.reduce((acc, addon) => {
    if (addon.isPerSeat()) acc[addon.periodUnit].perSeat = addon
    if (addon.isFee()) acc[addon.periodUnit].fee = addon
    if (addon.isTiered()) acc[addon.periodUnit].tiered = addon
    if (addon.isStairstep()) acc[addon.periodUnit].stairstep = addon
    return acc
  }, pricingAddonInitialState)

  if (!Object.keys(pricingAddon.month).length) return null

  return new Pricing(pricingAddon.month, pricingAddon.year, pricingAddon.six_months)
}

export default getF25PlanPricing
